import { Component, input } from '@angular/core';
import { ComponentVariant, ComponentSize } from '../types';

@Component({
  selector: 'app-progress-spinner',
  imports: [],
  template: `
    <div 
      [class]="spinnerClasses"
      [attr.role]="'progressbar'"
      [attr.aria-label]="label() || 'Loading'">
      <svg 
        class="animate-spin"
        [class]="svgClasses"
        fill="none"
        viewBox="0 0 24 24">
        <circle 
          class="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          stroke-width="4"></circle>
        <path 
          class="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      @if (label()) {
        <span [class]="labelClasses">{{ label() }}</span>
      }
    </div>
  `,
  styles: []
})
export class ProgressSpinnerComponent {
  label = input<string>('');
  variant = input<ComponentVariant>('primary');
  size = input<ComponentSize>('md');

  get spinnerClasses(): string {
    return 'flex flex-col items-center justify-center gap-2';
  }

  get svgClasses(): string {
    const sizeMap = {
      xs: 'w-4 h-4',
      sm: 'w-6 h-6',
      md: 'w-8 h-8',
      lg: 'w-12 h-12',
      xl: 'w-16 h-16'
    };

    const variantMap: Record<ComponentVariant, string> = {
      success: 'text-green-600 dark:text-green-400',
      error: 'text-red-600 dark:text-red-400',
      warning: 'text-yellow-600 dark:text-yellow-400',
      info: 'text-blue-600 dark:text-blue-400',
      primary: 'text-blue-600 dark:text-blue-400',
      secondary: 'text-gray-600 dark:text-gray-400',
      danger: 'text-red-600 dark:text-red-400'
    };

    return `${sizeMap[this.size()]} ${variantMap[this.variant()] || variantMap.primary}`;
  }

  get labelClasses(): string {
    return 'text-sm font-medium text-gray-600 dark:text-gray-400';
  }
}

